<template>
    <div v-if="Object.hasOwnProperty.call(obj,'cfda')" class="adv-list">
        <div class="regulations-aifm"><img :src="obj.cfda.image" alt="">
            <p v-html="obj.cfda.content"></p>
        </div>

        <div class="regulations-aifm"><img :src="obj.bda.image" alt="">
            <p v-html="obj.bda.content"></p>
        </div>

        <div class="play">
            <video ref="player" style="display:block" class="video-js vjs-default-skin vjs-big-play-centered" />
        </div>
        <!-- <div class="image-swiper">
            <swiper ref="mySwiper" :options="swiperOptions">
                <swiper-slide v-for='item of imageSwiper' :key='item.id'>
                    <a :href="`/detail?id=${item.id}`" target="_blank">
                    <img :src="item.image" alt="">
                    </a>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
        </div> -->
    </div>
</template>
<script>
import videojs from 'video.js'
// import { Swiper,SwiperSlide} from "vue-awesome-swiper";
import 'video.js/dist/video-js.css'
import 'swiper/css/swiper.css'
export default {
    components: {
       /*  Swiper,
        SwiperSlide */
    },
    data() {
        return {
            swiperOptions: {
                loop: true,
                autoplay: {
                    delay: 2500,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
            }
        }
    },
    props:{
        obj:{
            type:Object,
            defalut: () => {},
        },
        imageSwiper: {
            type: Array,
            defalut: () => [],
        }
    },
    mounted() {
        if(Object.hasOwnProperty.call(this.obj,'index_video')&&this.obj.index_video.image){
            this.initPlayer(this.obj.index_video.image);
        }
    },
    methods: {
        initPlayer(url){
            const that = this;
            const options = {
                controls: true,
                language: 'zh-CN',
                width:570,
                height: 344,
                controlBar:{
                    pictureInPictureToggle: false,
                },
            };
            // eslint-disable-next-line no-undef
            that.player = videojs(this.$refs.player, options, function onPlayerReady() {
                this.src(url);
            });
        }
    },
    computed: {
        /* swiper() {
            return this.$refs.mySwiper.$swiper
        } */
    },
}
</script>
<style lang="scss" scoped>
.adv-list{
    width: 1200px;
    margin: 0 auto;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
}
.regulations-aifm {
    width: 260px;
    height: 330px;
    margin-right: 20px;
    background: #f9f9f9;
    border-radius: 8px;
    padding: 16px;
    transition: all .3s linear;
    img{
        width: 260px;
        height: 145px;
        border-bottom: 1px solid #eee;
    }
    h2{
        margin: 10px 0 0;
        color: #333;
        line-height: 36px;
        font-size: 24px;
        text-align: center;
    }
    p{
        font-size: 14px;
        font-weight: 400;
        color: #616161;
        line-height: 24px;
        padding: 10px 0;
    }
}
.regulations-aifm:hover {color: red;background: #f9f9f9;box-shadow: 0 4px 10px rgba(63,63,63,.2)}
.play{
    width: 570px;
    height:344px;
    img{
        width:100%;
        height:100%;
        border-radius: 12px;
    }
}
.image-swiper {
    width: 570px;
    .swiper-slide {
        height: 362px;
    }
    img{
        height: 100%;
        width: 100%;
    }
}
</style>
